import { useState } from 'react';
import { useNavigate } from 'react-router';

import { ROUTES } from '@/components/Shared/routes/routes';
import { handleError } from '@/services/handleError';
import { dispatch } from '@/store';

import { ieLeasingApi, leasingApi } from '../../../api';
import { useCheckDealerForLeasing, useLeasingRequestId } from '../../hooks';
import { setActiveTabIndex, setRequestData } from '../store';
import useSelectedOffer from './useSelectedOffer';

const useFetchOrderData = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const { requestId, isCreateMode } = useLeasingRequestId();

  const { checkIsOfferSelected } = useSelectedOffer();

  const { checkDealerForLeasing } = useCheckDealerForLeasing();

  const fetchOrderData = async () => {
    if (!requestId) return;

    setIsLoading(true);

    try {
      const [requestResponse, filesResponse] = await Promise.all([
        ieLeasingApi.getRequestById(requestId),
        leasingApi.getLeasingFiles(requestId)
      ]);

      if (
        isCreateMode &&
        !checkDealerForLeasing(requestResponse.dealerUuid ?? '')
      ) {
        throw new Error('Dealer is not available for leasing');
      }

      const financedIndex = requestResponse.responses.findIndex((offer) =>
        checkIsOfferSelected(offer)
      );

      dispatch(
        setRequestData({ request: requestResponse, files: filesResponse })
      );
      dispatch(
        setActiveTabIndex(
          financedIndex !== -1
            ? 2
            : requestResponse.status.code !== 'leasing_draft'
              ? 1
              : 0
        )
      );
    } catch (error) {
      handleError(error, {
        customTitle: 'Ошибка при получении данных заявки',
        customDescription: 'Заявка либо не найдена, либо не доступна',
        onError: () => {
          navigate(`${ROUTES.leasings}?tab=legal-entity`);
        }
      });
    } finally {
      setIsLoading(false);
    }
  };

  return { fetchOrderData, isLoading };
};

export default useFetchOrderData;
